(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function moveGalleryIfWidthLessThanThreshold() {
    const widthThreshold = 1000;
    const windowWidth = window.innerWidth;
    const galleryElement = document.querySelector('product-gallery');
    const affirmBlock = document.querySelector('[data-block-id*="affirm_pay_over_time_messaging_product_block"]');
    const priceElement = affirmBlock || document.querySelector('[data-block-id="price"]');
    const inicialContainer = document.querySelector('product-rerender div.product');


    if (windowWidth <= widthThreshold && galleryElement && priceElement) {
      priceElement.parentNode.insertBefore(galleryElement, priceElement.nextSibling.nextSibling);
    } else if (windowWidth > widthThreshold && galleryElement && priceElement && inicialContainer) {
      inicialContainer.insertBefore(galleryElement, inicialContainer.firstChild);
    }
  }

  window.addEventListener('resize', moveGalleryIfWidthLessThanThreshold);
  moveGalleryIfWidthLessThanThreshold();

  } catch(e) { console.error(e); }
})();
})();
